import styled from "styled-components";

export const StyledCloseButton = styled.button`
  position: relative;
  background: transparent;
  color: #d10000;
  font-weight: bold;
  font-size: 1.4rem;
  border: none;
  cursor: pointer;
  visibility: ${(props) => (props.state === "error" ? "visible" : "hidden")};
  svg {
    width: 24px;
    height: 24px;
  }
  @media only screen and (max-width: 767px) {
    svg {
      width: 15px;
      height: 15px;
    }
  }
  @media (min-width: 768px) and (max-width: 1440px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
